export default function getDateForTitle(date, context) {
  if (!date) {
    return 'N/A'
  }

  var weekDays = context.$t('weekDays');
  var months = context.$t('months');

  var dtt = new Date(date);
  return weekDays[dtt.getDay()] + ', ' + dtt.getDate() + ' ' +  months[dtt.getMonth()].toUpperCase();
}


// WEBPACK FOOTER //
// ./src/app/filters/getDateForTitle.js